export default "__VITE_ASSET__yNKF5Se2__"